module.exports = __webpack_public_path__ + "img/spain-other-heart-diseases-male.23a576c2.png";